import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './PricingSection.module.css';

const DURATION_KEYS = ['duration1Day', 'duration3to6', 'duration7to13', 'duration14to29', 'durationMonthly'];

const scooters = [
  {
    id: 5,
    name: 'Honda Scoopy',
    tag: '110cc',
    prefix: 's1',
    image: 'honda-scoopy.png',
    pricing: ['260 THB', '240 THB', '220 THB', '200 THB', '5,500 THB'],
    imageLeft: false,
  },
  {
    id: 1,
    name: 'Honda Click 125',
    tag: '125cc',
    prefix: 's2',
    image: 'honda-click-125.png',
    pricing: ['320 THB', '290 THB', '260 THB', '230 THB', '6,500 THB'],
    imageLeft: true,
  },
  {
    id: 2,
    name: 'Honda Click 160',
    tag: '160cc',
    prefix: 's3',
    image: 'honda-click-160.png',
    pricing: ['350 THB', '320 THB', '290 THB', '260 THB', '7,200 THB'],
    imageLeft: false,
  },
  {
    id: 3,
    name: 'Honda PCX 160',
    tag: '160cc',
    prefix: 's4',
    image: 'honda-pcx.png',
    pricing: ['420 THB', '390 THB', '350 THB', '320 THB', '9,000 THB'],
    imageLeft: true,
  },
  {
    id: 4,
    name: 'Honda ADV 160',
    tag: '160cc',
    prefix: 's5',
    image: 'honda-avd-160.png',
    pricing: ['500 THB', '460 THB', '420 THB', '380 THB', '11,000 THB'],
    imageLeft: false,
  },
  {
    id: 6,
    name: 'Honda ADV 350',
    tag: '350cc',
    prefix: 's6',
    image: 'honda-adv-350.png',
    pricing: ['1,000 THB', '900 THB', '850 THB', '800 THB', '18,000 THB'],
    imageLeft: true,
  },
];

function PricingSection() {
  const { t } = useTranslation();
  const baseUrl = process.env.PUBLIC_URL || '';
  const imgSrc = (filename) => (baseUrl ? `${baseUrl}/${filename}` : `/${filename}`);

  return (
    <section id="pricing" className={styles.section}>
      <h2 className={styles.heading}>{t('pricing.heading')}</h2>
      <p className={styles.subheading}>
        {t('pricing.subheading')}
      </p>
      <p className={styles.highlight}>
        <span className={styles['highlight-icon']}>💰</span>
        {t('pricing.highlight')}
      </p>

      {scooters.map((scooter) => (
        <div
          key={scooter.id}
          className={`${styles.row} ${scooter.imageLeft ? '' : styles['row-reverse']}`}
        >
          <div className={styles['col-image']}>
            <div className={styles['image-card']}>
              <img src={imgSrc(scooter.image)} alt={`${scooter.name} - Scooter rental Phuket`} loading="lazy" />
            </div>
          </div>
          <div className={styles['col-content']}>
            <div className={styles.card}>
              <span className={styles.tag}>{scooter.tag}</span>
              <h3 className={styles.title}>{scooter.name}</h3>
              <p className={styles.tagline}>{t(`pricing.${scooter.prefix}Tagline`)}</p>
              <p className={styles.description}>{t(`pricing.${scooter.prefix}Desc`)}</p>
              <ul className={styles.features}>
                {[1, 2, 3, 4].map((i) => (
                  <li key={i}>
                    <span className={styles.check}>✓</span> {t(`pricing.${scooter.prefix}f${i}`)}
                  </li>
                ))}
              </ul>
              <div className={styles['pricing-card']}>
                <h4 className={styles['pricing-title']}>{t('pricing.rentalPricing')}</h4>
                <div className={styles['pricing-table']}>
                  {scooter.pricing.map((price, i) => (
                    <div key={i} className={styles['pricing-row']}>
                      <span className={styles['pricing-duration']}>{t(`pricing.${DURATION_KEYS[i]}`)}</span>
                      <span className={styles['pricing-price']}>{price}</span>
                    </div>
                  ))}
                </div>
                <a
                  href="https://wa.me/66943672385"
                  target="_blank"
                  rel="noopener noreferrer"
                  className={styles.button}
                >
                  {t('pricing.bookWhatsApp')}
                </a>
              </div>
            </div>
          </div>
        </div>
      ))}
    </section>
  );
}

export default PricingSection;
